module.exports = __webpack_public_path__ + "img/hascharge.3842662a.svg";